import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import CheckAuth from '../../../utils/hoc/CheckAuth';
import Button from '../../../components/atoms/Button';
import { connect } from 'react-redux';
import {Disbursement, Repayment} from '../../../redux/actions/RiwayatTransaksi'
import Loading from '../../../components/molecules/Loading';
import curencyFormat from '../../../utils/helpers/curencyFormat';
import DataTable from '../../../containers/organism/DataTable';
import ModalInformation from '../../organism/ModalInformation';

class RiwayatTransaksi extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTable : 1,
            modal : {
                show : false,
                content : ''
            },
			coloumnDataPayment : [
				{ data: "loanCode",				width : "25%", title: "Kode Pinjaman" },
				{ data: "voucherID",			width : "25%", title: "No. Transaksi" },
				{ data: "transactionAmount",	width : "15%", title: "Nilai Transaksi" },
				{ data: "transactionType",		width : "15%", title: "Jenis Transaksi" },
				{ data: "status",				width : "10%", className : "dt-center", title: "Status" },
				{ data: "note",					width : "10%", title: "Catatan" }
			],
			coloumnDefsPayment : [
				{
					targets: 2,
					createdCell: (td, cellData, rowData, row, col) => { 
						ReactDOM.render( <span> Rp {curencyFormat(cellData)} </span>, td );
					}
				},
				{
					targets: 5,
					createdCell: (td, cellData, rowData, row, col) => { 
						ReactDOM.render( <Button title='Lihat' width='small' color='blue' onClick={() => this.setState({ modal : {show : true, content : cellData} }) } />, td );
					}
				}
			],
			coloumnDataDisburse : [
				{ data: "loanCode",				width : "150", title: "Kode Pinjaman" },
				{ data: "voucherID",			width : "150", title: "No. Transaksi" },
				{ data: "transferType",			width : "120", title: "Jenis Transaksi" },
				{ data: "bankName",				width : "80", title: "Nama Bank" },
				{ data: "accountNumber",		width : "100", title: "No. Rekening" },
				{ data: "accountHolderName",	width : "180", title: "Nama Pemilik Rekening" },
				{ data: "loanAmount",			width : "120", title: "Jumlah Pinjaman" },
				{ data: "transferAmount",		width : "120", title: "Jumlah Pencairan" },
				{ data: "status",				width : "100", className : "dt-center", title: "Status" },
				{ data: "note",					width : "100", className : "dt-center", title: "Catatan" }
			],
			coloumnDefsDisburse : [
				{
					targets: 6,
					createdCell: (td, cellData, rowData, row, col) => { 
						ReactDOM.render( <span> Rp {curencyFormat(cellData)} </span>, td );
					}
				},
				{
					targets: 7,
					createdCell: (td, cellData, rowData, row, col) => { 
						ReactDOM.render( <span> Rp {curencyFormat(cellData)} </span>, td );
					}
				},
				{
					targets: 9,
					createdCell: (td, cellData, rowData, row, col) => { 
						ReactDOM.render( <Button title='Lihat' width='small' color='blue' onClick={() => this.setState({ modal : {show : true, content : cellData} }) } />, td );
					}
				}
			]
		};
	}

	changeTable = (val) => {
		this.setState({
			...this.state,
			activeTable : val
		})
	}

	componentDidMount = () => {
		const {setTitlePage, RefreshToken, getDisburse, getPayment, setClientID} = this.props;

		setTitlePage({
			title : 'Riwayat Transaksi',
			breadcrumb : [
				{name : 'Beranda', url : '/dashboard', status : false},
				{name : 'Riwayat Transaksi', url : '/#', status : true},
			]
		});
		
		RefreshToken(ClientID => {
			if(ClientID){
				getDisburse(ClientID);
				getPayment(ClientID);
			}
		});
	}

	render() {
		const {activeTable, modal} = this.state;
		const {disburse, payment, status} = this.props;

		const modalProps = {
            show : modal.show, 
            title : 'Catatan', 
            content : modal.content,
            icon : 'img/icon/icon-riwayat-penarikan.png',
            actClose : () => {this.setState({ modal : {
                show : false,
                content : ''
            }})}
        }

		
		return (
			(status.loadingPage || disburse.isLoading || payment.isLoading) ? <Loading /> : (
				<Fragment>
					<div className='bg-vertical-scroll bg-button-vertical'>
						<Button title='Pencairan' onClick={e => this.changeTable(1)} type='button' color={activeTable === 1 ? 'yellow' : 'outline'} width='small-rounded' />
						<Button title='Pembayaran' onClick={e => this.changeTable(2)} type='button' color={activeTable === 2 ? 'yellow' : 'outline'} width='small-rounded' />
					</div>
					
					<DataTable 
						isDisplay = {activeTable === 1 ? true : false}
						data = {disburse.list} 
						idTable = 'disburse'
						fixedWidthColoumn = {true}
						coloumn = {this.state.coloumnDataDisburse} 
						coloumnDefs = {this.state.coloumnDefsDisburse}
					/>
					
					<DataTable 
						isDisplay = {activeTable === 2 ? true : false}
						data = {payment.list} 
						idTable = 'payment'
						coloumn = {this.state.coloumnDataPayment} 
						coloumnDefs = {this.state.coloumnDefsPayment}
					/>

					<ModalInformation {...modalProps} />
				</Fragment>
			)
		);
	}
}


const mapStateToProps = state => {
	return {
		disburse : state.disburseState,
		payment : state.paymentState

	}
}

const mapDispatchToProps = dispatch =>{
    return {
		getDisburse : ClientID => {
			dispatch(Disbursement(ClientID))
		},
		getPayment : ClientID => {
			dispatch(Repayment(ClientID))
		}
	}
}


export default CheckAuth(connect(mapStateToProps, mapDispatchToProps)(RiwayatTransaksi));